<template>
	<b-card>
		<div slot="header">
			<b-row>
				<b-button @click="cancelAndBack" class="ml-3 mr-1 fa fa-arrow-circle-left" variant="dark" style="font-size: 22px; padding: 0 10px;"/>
				<b-col>
					<multiselect
						v-model="dep"
						:options="departments"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						label="name"
						:placeholder="$t('promo-to-product.department')"
						class="multiselect-pricing"
					/>
				</b-col>
				<b-col>
					<multiselect
						label="itemName"
						track-by="id"
						:disabled="!dep"
						:options="items"
						:searchable="true"
						:show-labels="false"
						:close-on-select="true"
						:internal-search="true"
						v-model="item"
						@select="addItem($event)"
						class="multiselect-pricing"
						:placeholder="$t('restaurant.product')"
					>
						<template slot="option" slot-scope="props">
							{{ props.option.itemName }} / <b>€ {{ props.option.priceUzs }} / {{props.option.incomeParentRegNumber}}/ {{ props.option.termOfItem }} /{{props.option.childPriceUzs}}</b>
						</template>
					</multiselect>
				</b-col>
				<b-button v-if="dep" @click="save" class="mr-3" variant="success">{{$t('pending.done')}}</b-button>
			</b-row>
		</div>
		<b-row class="mt-3">
			<b-col>
				<table id="table" class="table-striped table-bordered table-hover" style="width: 100%">
					<thead>
					<tr>
						<th class="text-center">{{ '№' }}</th>
						<th class="text-center">{{ 'Документ №' }}</th>
						<th class="text-center">{{ $t('name') }}</th>
						<th class="text-center">{{ 'Прод.в сумах' }}</th>
						<th class="text-center">{{ $t('remaining') }}</th>
						<th class="text-center">{{ $t('incomes.create.count') }}</th>
					</tr>
					</thead>
					<tbody v-for="(item, index) in localItems" :key="`table-${index}`">
					<tr>
						<td class="text-center">{{ index+1 }}</td>
						<td class="text-center">{{ item.incomeParentRegNumber }}</td>
						<td class="text-center">{{ item.itemName }}</td>
						<td class="text-center">{{ item.priceUzs }}</td>
						<td class="text-center">{{ item.remaining }}</td>
						<td class="text-center"><b-input v-model="item.count" :name="`count-${index}`" type="number" @input="countInput($event , item)"/></td>
					</tr>
					</tbody>
				</table>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect"
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";
import CollectService from "@/services/collect.service";

export default {
	name: "CreateOrUpdate",
	components: {Multiselect},
	data() {
		return {
			items: [],
			localItems: [],
			departments: [],
			dep: null,
			name: '',
			loading: false,
			depDisable: false,
			item:null
		}
	},
	watch:{
		'dep':{
			handler(g){
				this.items = []
				this.localItems= []
				if (g){
					CollectService.depCollectService(g.id,{search:{value:""}}).then(res => {
						this.items = res.data
					}).catch(e=>{
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
				else {
					this.localItems= null
					this.dep = null
				}
			}
		},
	},
	methods: {
		addItem(g){
			g.count = 0
			if (this.localItems.length>0){
				let temp = true
				this.localItems.forEach(e=>{
					if (e.incomeParentWhDocItemId == g.incomeParentWhDocItemId){temp = false}
				})
				if (temp){
					this.localItems.push(g)
				}
				else {

				}
			}
			else {
				this.localItems.push(g)
			}
		},
		cancelAndBack() {
			this.dep = null
			this.items = []
			this.localItems = []
			this.depDisable = false
			this.$router.go(-1);
		},
		async countInput(event,item){
			console.log(item)
			if (Number(event) > item.remaining){
				return item.code = item.remaining
			}
		},
		save(){
			if (this.localItems.length>0){
				CollectService.created(this.dep.id,this.localItems).then(res=>{
					this.cancelAndBack()
				}).catch(e=>{
					console.log(e)
				})
			}
			else {
				console.log('error')
			}
		}
	},
	created() {
		UsersService.getPermittedDepartments().then(res => {
			this.departments = res.data.permittedDepartments
		})
	}
}
</script>

<style scoped>

</style>
